import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { ReactNode } from 'react';

export type LoadingState = {
  isLoading?: boolean;
  message?: string | string[];
  customLoader?: ReactNode;
};

export const OverlayLoader = ({
  isLoading = false,
  message,
  customLoader,
}: LoadingState) => {
  if (!isLoading) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="absolute inset-0 bg-background/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center gap-4 rounded-lg p-5">
      {customLoader || (
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      )}
      <p className="text-center">{message}</p>
    </motion.div>
  );
};
